import { EnterpriseLandingPageTemplate } from "@/templates/enterprise/enterprise-landing-page";

export const EnterpriseLandingPage = () => {
    return <EnterpriseLandingPageTemplate />;
};
